"use strict";

const certificazioni = document.querySelector(".certificazioni");

const addCurrent = () => {
  certificazioni.classList.add("current");
};
addCurrent();
